import { Navigate, RouteProps } from 'react-router-dom';
import React from 'react';
import { ROUTES } from 'constants/routes';
import { useAuth } from 'contexts/authContext';
import { getItem } from '@utils/localStorage';

interface ProtectedRouteProps extends Omit<RouteProps, 'children'> {
  children: React.ReactElement;
}

const WithNotAuth: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const temp = getItem('isLoginInitiated');

  return isLoggedIn || temp ? (
    <Navigate to={ROUTES.CUSTOMER_DELIVERY_FILES.ROOT} replace />
  ) : (
    children
  );
};

export default WithNotAuth;
